import { CustomTableColumn } from "./custom-table-column";

export class PartnerLinkTableColumn extends CustomTableColumn {
    idPath: string;

    constructor(label: string, path: string, idPath?: string) {
        super("partnerName", label, path);
        this.idPath = idPath;
    }
}
